import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import './SelectedSong.scss';
import SongCard from '../SongCard/SongCard';
import {FuntoneSubscriptionStatus} from './../../FuntoneSlice';

const SelectedSong = ({title, song, selectedPackage, showPrice = false, className}) => {
  const {selectedSubscriber, subscribersData} = useSelector((state) => state.FuntoneSlice);

  const safeSong = {
    id: (song && (song.id || song.productId)) || null,
    description: song.description || song.title,
    author: (song && (song.author || song.artist || song.artistName)) || '',
    image: (song && (song.image || song.albumArt)) || null,
    isDownloadable: false,
    isPlayable: false,
  };

  return (
    <div className={`selected-song-container ${className || ''}`}>
      <div className='selected-song-inner'>
        <span className='song-header'>{title}</span>
        <div className='selected-song-card'>
          <SongCard song={safeSong} />
        </div>

        {(selectedPackage || (selectedSubscriber.hasService && showPrice)) && <div className='divider' />}
        {(selectedPackage || (selectedSubscriber.hasService && showPrice)) && (
          <div className='package-block'>
            <div className='package-top-content'>
              <div className='package-title'>
                {selectedSubscriber.hasService && ' יש לך'} {selectedPackage?.title?.value}
              </div>

              {!selectedSubscriber.hasService && (
                <div className='package-price'>
                  ₪{selectedPackage?.price?.value}
                  <span className='per-month'>לחודש</span>
                </div>
              )}
            </div>
            <div className='package-bottom-content'>
              <div className='package-benefits'>{selectedPackage?.description?.value}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedSong;
